import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";
import type { IDiseasesEndpoint } from "@api/infinite";

const { key, getPath } = getApi("infinite.getAllDiseases");

type IResponse = IWithInfinite<IDiseasesEndpoint>;
type IVariables = object;

const getAllInfiniteDiseases = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteDiseases = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteDiseases({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
